import axios from 'axios';
import config from '../config';
//import NProgress from 'nprogress';
import router from '@/router/index';
import * as cache from '@/libs/cache';
import { useUserStore } from '@/store/modules/user';
//import 'nprogress/nprogress.css';
import { useCookies } from '@/libs/cookie';
import { isEmpty } from '@/libs/utils';
import storage from '@/libs/storage';

const cookie = useCookies();
const httpService = axios.create({
    baseURL: config.base_url,
    timeout: config.request_timeout
});

// 添加请求拦截器
httpService.interceptors.request.use(config=>{
  //NProgress.start();

  let token = useUserStore().getToken();
  if(token){
    config.headers["Authorization"] = "Bearer " + token;
  }

  let oauth = cookie.get("oauth");
  if(!isEmpty(oauth)){
    config.headers["Authorization"] = "Bearer " + oauth;
    storage.set("pc_token",oauth);
    cookie.remove("oauth");
  }

  config.headers["Client-Type"] = "pc";
  return config;
},error=>{
  return Promise.reject(error);
});

// 添加响应拦截器
httpService.interceptors.response.use(function (response) {
    //NProgress.done();
    
    let result = response.data;
    if(result.code == 401){
      cache.clear();
      router.push("/user/login");
      return ;
    }else if(result.code == 402){
      ElMessage.error(result.msg);
      return ;
    }else if(result.code == 404){
      router.push("/public/404");
      return ;
    }
    
    return response.data;
  }, function (error) {
    return Promise.reject(error);
});

export default httpService;